import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import { makeStyles, useTheme } from '@mui/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import DataContext from '../data/data-context';

const useStyles = makeStyles(theme => ({
    card: {
        maxWidth: 345,
        position: 'relative',
    },
    media: {
        height: 140,
    },
    statusContainer: {
        width: '100%',
        position: 'absolute',
        zIndex: 100,
    },
    critical: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        height: '30px',
        width: '30px',
        background: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        borderRadius: '20px',
        textAlign: 'center',
        fontSize: '1.25rem',
    },
    defaultContentHeight: {
        padding: '8px',
        minHeight: '152px',
    },
}));

const DisplayCard = (props) => {
    const theme = useTheme();
    const classes = useStyles();
    const navigate = useNavigate();
    const [status, setStatus] = useState('');
    const { systemHealth } = useContext(DataContext);

    useEffect(() => {
        if (systemHealth && props.title === 'CMC Health') {
            setStatus(systemHealth.object.status);
        }
    }, [systemHealth, props.title]);

    const handleSelect = (route) => {
        navigate(route);
    };

    return props.hide ? null : (
        <Card className={classes.card}>
            <Box className={classes.statusContainer} display={status ? 'block' : 'none'}>
                <Box className={classes.critical} display={(status === 'critical' || status === 'warning') ? 'block' : 'none'}>!</Box>
            </Box>
            <CardActionArea aria-label={props.title} onClick={() => { props.noButton ? handleSelect(props.route) : noop() }}>
                {props.img && <CardMedia className={classes.media} image={props.img} title={props.title} style={!props.backgroundColor ? {
                    backgroundColor: theme.palette.nav.nested
                } : {
                    backgroundSize: 'contain',
                    backgroundColor: props.backgroundColor
                }}/>}
                <CardContent className={classes.defaultContentHeight}>
                    <Typography gutterBottom variant="h5" component="h2">{props.title}</Typography>
                    { props.subtitle &&
                      <Typography gutterBottom variant="subtitle1">{props.subtitle}</Typography>
                    }
                    <Typography>{props.description || ''}</Typography>
                </CardContent>
            </CardActionArea>
            {!props.noButton &&
                <CardActions>
                    <Button aria-label={'select ' + props.title} onClick={() => { handleSelect(props.route) }}>Select</Button>
                </CardActions>
            }
        </Card>
    );
};

DisplayCard.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    img: PropTypes.string,
    route: PropTypes.string.isRequired,
    noButton: PropTypes.bool,
    backgroundColor: PropTypes.string,
    hide: PropTypes.bool,
};

export default DisplayCard;
